import { render, staticRenderFns } from "./ThePublicHeader.vue?vue&type=template&id=38ea6d7c&"
import script from "./ThePublicHeader.vue?vue&type=script&lang=ts&"
export * from "./ThePublicHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ThePublicHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports